import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'booleanValue'
})
export class BooleanValuePipe implements PipeTransform {
  transform(source: boolean): string {
    if (source) {
      return "Yes";
    } else {
      return "No";
    }
  }
}
